import React, {Component} from "react";
import {Link} from "react-router";
import {FormattedDate, FormattedTime} from "react-intl";
import "./DashboardPanel.css"

class BotStatusPanel extends Component {
    describeBot() {
        const botStatus = this.props.status;

        const botPanel = {
            className: '',
            title: '',
            subtitle: '',
            description: ''
        };

        switch (botStatus.status) {
            case 'LOADING':
                botPanel.className = 'panel-default';
                botPanel.title = 'Slack Bot Status';
                botPanel.subtitle = 'Loading bot status';
                botPanel.description = '';
                break;

            case 'UPDATING':
                botPanel.className = 'panel-warning';
                botPanel.title = 'Slack Bot Updating';
                botPanel.subtitle = 'Your bot is updating.';
                botPanel.description = (
                    <span>
                        Your updates are being applied to your bot.
                        This may take a few minutes to complete.
                    </span>
                );
                break;

            case 'ACTIVE':
                botPanel.className = 'panel-success';
                botPanel.title = 'Slack Bot Active';
                botPanel.subtitle = 'Your bot is active and connected to Slack.';
                botPanel.description = (
                    <span>
                        Bot last connected
                        {' '}at <FormattedTime value={botStatus.started}/>
                        {' '}on <FormattedDate value={botStatus.started}
                                               day="numeric"
                                               month="long"
                                               year="numeric"/>.

                        {' '}It is configured to reply in the following channel(s): <i>{botStatus.channels || 'none'}</i>.
                    </span>
                );
                break;

                // handle retired and inactive the same way
            case 'RETIRED':
            case 'INACTIVE':
                botPanel.className = 'panel-warning';
                botPanel.title = 'Slack Bot Inactive';
                botPanel.subtitle = 'Your bot is not running.';
                botPanel.description = 'Set up your connections and save changes to start your bot.';
                break;

            case 'FAILED':
                botPanel.className = 'panel-danger';
                botPanel.title = 'Slack Bot Error';
                botPanel.subtitle = 'Your bot encountered an error.';
                botPanel.description = (
                    <span>
                        Your bot failed during startup. Often this is due to an incorrect Slack token.
                        Please check your connection settings and try again.
                    </span>
                );
                break;

            default:
                botPanel.className = 'panel-danger';
                botPanel.title = 'Slack Bot Status Unknown';
                botPanel.subtitle = 'The status of your bot is unknown.';
                botPanel.description = '';
                break;
        }
        return botPanel;
    }

    render() {
        const botPanel = this.describeBot();

        return (
            <div className="col-sm-6">
                <div className={`panel panel-bold ${botPanel.className}`}>
                    <div className="panel-body dashboard-panel p-b">
                        <h3 className="m-y-0">{botPanel.title}</h3>
                        <p>{botPanel.subtitle}</p>
                        <hr/>

                        <div className="row">
                            <div className="col-md-7">
                                <p>{botPanel.description}</p>
                            </div>
                            <div className="visible-xs visible-sm m-t"/>
                            <div className="col-md-5 dashboard-panel-button">
                                <Link to="/bot/connections" className="btn btn-default">Edit Connections</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BotStatusPanel.propTypes = {
    status: React.PropTypes.object
};

export default BotStatusPanel;



// WEBPACK FOOTER //
// ./src/modules/common/BotStatusPanel.js